function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2506 0H0.749388C0.334286 0 0 0.368 0 0.82V16.18C0 16.632 0.334286 17 0.749388 17H17.2506C17.6657 17 18 16.632 18 16.18V0.82C18 0.368 17.662 0 17.2506 0ZM16.4976 10.564H11.3327C10.2931 10.564 9.44816 9.636 9.44816 8.5C9.44816 7.36 10.2931 6.436 11.3327 6.436H16.5012V10.564H16.4976ZM1.49878 15.356V1.644H16.4976V4.792H11.3327C9.46653 4.792 7.94571 6.456 7.94571 8.5C7.94571 10.544 9.46286 12.208 11.3327 12.208H16.5012V15.356H1.49878ZM10.9616 8.496V8.508C10.9616 8.96 11.2959 9.324 11.711 9.324C12.1261 9.324 12.4604 8.952 12.4604 8.496C12.4604 8.044 12.1261 7.676 11.711 7.676C11.2959 7.672 10.9616 8.04 10.9616 8.496Z",
  fill: "white"
});

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.073417c5.svg";
export { ForwardRef as ReactComponent };